module.exports = __webpack_public_path__ + "img/icon_map_3_off_100.de927b4c.png";